import { Check, Rocket, Sparkles, Zap } from 'lucide-react';
import { GradientButton } from '@/components/common';
import { useNavigate } from 'react-router-dom';

export default function PricingPlans() {
	const plans = [
		{
			title: "Standard",
			icon: Rocket,
			description: "Perfect for personal and blog websites",
			monthlyPrice: "$2.22",
			yearlyPrice: "$1.99",
			features: [
				"Standard Authentication",
				"Single Website",
				"256 Bit Encryption",
				"$500,000 Warranty",
				"~"
			]
		},
		{
			title: "Premium EV",
			icon: Zap,
			description: "The most trusted SSL for business websites",
			monthlyPrice: "$12.10",
			yearlyPrice: "$10.99",
			features: [
				"Strongest Authentication + EV",
				"Single Website",
				"256 Bit Encryption",
				"$1,750,000 Warranty",
				"Official Site Seal"
			],
			recommended: true
		},
		{
			title: "Wildcard",
			icon: Sparkles,
			description: "For websites with multiple sub domains",
			monthlyPrice: "$30.25",
			yearlyPrice: "$21.99",
			features: [
				"Strongest Authentication",
				"Multiple Website",
				"256 Bit Encryption",
				"$1,000,000 Warranty",
				"Official Site Seal"
			]
		}
	];

	const navigate = useNavigate();

	const handleContactClick = () => {
		navigate('/request-for-services');
	};

	return (
		<div className="container py-12 pb-32">
			{/* Header */}
			<h3 className="text-3xl md:text-4xl text-center font-bold text-white md:leading-tight mb-12">
				SSL Certificate Plans
			</h3>

			{/* Pricing Cards */}
			<div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto mb-12 items-stretch">
				{plans.map((plan, index) => (
					<div key={index} className="relative h-full">
						{/* Recommended Badge */}
						{plan.recommended && (
							<div className="absolute -top-4 left-0 right-0 z-10 flex justify-center">
								<div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wide shadow-lg">
									Recommended
								</div>
							</div>
						)}

						<div
							className={`h-full flex flex-col bg-gradient-to-br from-gray-900/50 to-gray-800/50 backdrop-blur-xl rounded-2xl p-6 border ${
								plan.recommended
									? 'border-purple-500/50 shadow-2xl shadow-purple-500/20'
									: 'border-purple-500/20'
							} hover:border-purple-500/50 transition-all duration-300`}
						>
							{/* Icon */}
							<div className="mb-6 flex justify-center">
								<div className="w-16 h-16 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center">
									<plan.icon className="w-8 h-8 text-white" strokeWidth={2} />
								</div>
							</div>

							{/* Title */}
							<h2 className="text-white text-xl font-bold mb-3 leading-snug min-h-[56px] text-center">
								{plan.title}
							</h2>

							{/* Description */}
							<p className="text-gray-300 text-sm text-center mb-6">
								{plan.description}
							</p>

							{/* Divider */}
							<div className="h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent mb-6" />

							{/* Features */}
							<div className="flex-grow">
								<ul className="space-y-4">
									{plan.features.map((feature, idx) => (
										<li key={idx} className="flex items-start gap-3">
											<div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-0.5">
												<Check className="w-3 h-3 text-white" strokeWidth={2.5} />
											</div>
											<span className="text-gray-300 text-sm leading-relaxed">
												{feature}
											</span>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				))}
			</div>

			{/* Single CTA Button */}
			<div className="flex justify-center">
				<GradientButton 
					className="px-12 py-4 text-white font-semibold text-lg" 
					onClick={handleContactClick}
				>
					Get Started
				</GradientButton>
			</div>
		</div>
	);
}